import React, { useState } from 'react';
import './whatsNew.css';

import buttonArrow from '../../assets/icons/button-arrow.svg';
import heroBannerImg from '../../assets/whats-new/hero-banner.png';
import eventsMain from '../../assets/whats-new/events-main.png';
import eventsSide from '../../assets/whats-new/events-side.png';
import thumb1 from '../../assets/whats-new/thumb-1.png';
import thumb2 from '../../assets/whats-new/thumb-2.png';
import thumb3 from '../../assets/whats-new/thumb-3.png';
import newsletterArt from '../../assets/whats-new/newsletter-art.png';
import { sendContactEmail } from '../../utils/emailjs';

const WhatsNew = () => {
  const [newsletterForm, setNewsletterForm] = useState({
    name: '',
    email: '',
    intro: '',
  });

  const onNewsletterChange = (e) => {
    setNewsletterForm({ ...newsletterForm, [e.target.name]: e.target.value });
  };

  const handleNewsletterSubmit = async (event) => {
    event.preventDefault();
    await sendContactEmail(newsletterForm, 'Whats New Newsletter');
    setNewsletterForm({
      name: '',
      email: '',
      intro: '',
    });
  };

  return (
    <div className="kw__whatsnew">
      <section className="kw__whatsnew_hero kw__whatsnew_section">
        <h1 className="kw__whatsnew_hero-title">
          Driving Impact: Kothawala Group
          <br />
          Expands Corporate Horizons
        </h1>
        <p className="kw__whatsnew_hero-copy">
          From scaling our BPO operations to breaking new ground in sustainable tech and global trade, see how our cross-industry synergy is shaping
          tomorrow. Explore our latest venture milestones and global expansions.
        </p>
      </section>

      <section className="kw__whatsnew_insights kw__whatsnew_section">
        <h2 className="kw__whatsnew_title">Perspectives &amp; Insights</h2>
        <p className="kw__whatsnew_subtitle">
          Expert commentary, trend analysis, and leadership ideas across real estate, telecom, retail, and tech.
        </p>

        <div className="kw__whatsnew_cards">
          <div className="kw__whatsnew_card kw__whatsnew_card--coming-soon">
            <p className="kw__whatsnew_coming-soon">Coming Soon</p>
          </div>
        </div>
      </section>

      <section className="kw__whatsnew_banner">
        <img src={heroBannerImg} alt="City skyline" />
        <p className="kw__whatsnew_banner-word">Acquire.</p>
      </section>

      <section className="kw__whatsnew_events kw__whatsnew_section">
        <p className="kw__whatsnew_label">Events</p>
        <h2 className="kw__whatsnew_title">On the Calendar</h2>
        <p className="kw__whatsnew_subtitle">
          Join us at our global exhibitions, networking summits, and community outreach initiatives.
        </p>

        <div className="kw__whatsnew_events-grid">
          <div className="kw__whatsnew_events-main-wrap">
            <img src={eventsMain} alt="Annual summit" className="kw__whatsnew_events-main" />
            <div className="kw__whatsnew_events-thumbs">
              <img src={thumb1} alt="Event thumbnail" />
              <img src={thumb2} alt="Event thumbnail" />
              <img src={thumb3} alt="Event thumbnail" />
              <img src={eventsSide} alt="Event thumbnail" />
            </div>
          </div>

          <div className="kw__whatsnew_events-side-wrap">
            <img src={eventsSide} alt="Corporate team" className="kw__whatsnew_events-side" />
            <div className="kw__whatsnew_events-card">
              <p className="kw__whatsnew_events-kicker">Signature Event:</p>
              <h3>Annual Global Strategy Summit</h3>
              <p>
                Aligning leadership teams, showcasing internal project milestones, and discussing the roadmap for our next phase of new venture
                development.
              </p>
              <div className="kw__whatsnew_events-actions">
                <div className="kw__whatsnew_events-meta-block">
                  <p className="kw__whatsnew_events-status">What to Expect</p>
                  <p className="kw__whatsnew_events-meta">Leadership briefings, venture updates, and strategic networking.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="kw__whatsnew_newsletter kw__whatsnew_section">
        <div className="kw__whatsnew_newsletter-copy">
          <p className="kw__whatsnew_label">Newsletter</p>
          <h2 className="kw__whatsnew_title">Never Miss An Update</h2>
          <p className="kw__whatsnew_subtitle">
            Subscribe to our corporate newsletter to receive quarterly highlights, industry research, and exclusive event invitations directly to your
            inbox.
          </p>
        </div>

        <form className="kw__whatsnew_newsletter-form" onSubmit={handleNewsletterSubmit}>
          <div className="kw__whatsnew_newsletter-row">
            <input name="name" type="text" placeholder="Name" value={newsletterForm.name} onChange={onNewsletterChange} />
            <input name="email" type="email" placeholder="Email address" value={newsletterForm.email} onChange={onNewsletterChange} />
          </div>
          <textarea name="intro" placeholder="Introduction" value={newsletterForm.intro} onChange={onNewsletterChange} />
          <button type="submit" className="kw__whatsnew_newsletter-submit">
            <span>Submit</span>
            <img src={buttonArrow} alt="" />
          </button>
        </form>

        <img src={newsletterArt} alt="" className="kw__whatsnew_newsletter-art" aria-hidden="true" />
      </section>
    </div>
  );
};

export default WhatsNew;
